import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { ROLE } from '@/features/Clients/types';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VP]: {
    label: 'Angaben zur versicherten Person',
    component: () =>
      import(
        '@/features/Sparten/pkv/sections/input/InputVersichertePerson.vue'
      ),
  },
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/pkv/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/pkv/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.PKV_INPUT_GRUNDBAUSTEINE]: {
    label: 'Grundbausteine',
    component: () =>
      import('@/features/Sparten/pkv/sections/input/InputGrundbausteine.vue'),
  },
  [SECTION.PKV_INPUT_BAUSTEINE]: {
    label: 'Bausteine',
    component: () =>
      import('@/features/Sparten/pkv/sections/input/InputBausteine.vue'),
  },
  [SECTION.INPUT_VORVERSICHERUNG]: {
    label: 'Vorversicherung',
    component: () =>
      import(
        '@/features/Sparten/pkv/sections/input/InputPreviousInsurance.vue'
      ),
  },
};

const contractConfig: VersicherungsangabenSectionConfig = {
  [SECTION.CONTRACT_CLIENT_VP]: {
    label: 'Angaben zur versicherten Person',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
    componentProps: {
      role: ROLE.VERSICHERTE_PERSON,
      label: 'Angaben zur versicherten Person',
    },
  },
  [SECTION.CONTRACT_CLIENT]: {
    label: 'Angaben zu Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
    slots: {
      default: () =>
        import(
          '@/features/Sparten/pkv/sections/contract/ContractBankTransferInformation.vue'
        ),
    },
  },
};

export const pkvVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
  requiresCompanies: true,
};
